<bodyanalytics-main-nav style="margin-right: auto" />
<!-- Neither Login/Sign-up nor Log-out renders until Auth0 resolves the
     session (#1939) — showing either before that would either flash the
     anonymous CTAs at an authenticated visitor, or vice versa. -->
@if (!isLoading()) {
  @if (!isAuth()) {
    <bodyanalytics-login-button />
    <bodyanalytics-signup-button />
  } @else {
    <bodyanalytics-logout-button />
  }
}
